"use client"

import { useEffect, useRef } from "react"
import { useNavigate, Link } from "react-router-dom" // Añadido Link
import styles from "./Nosotros.module.css"
import profileImage from "../../assets/gladys_1.png"
import backgroundImage from "../../assets/opacidad_3.png"

const NosotrosParallax = () => {
  const serviciosRef = useRef(null)
  const navigate = useNavigate()

  // Scroll al inicio cuando se monta el componente
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  // Animación al hacer scroll
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(styles.animate)
          } else {
            entry.target.classList.remove(styles.animate)
          }
        })
      },
      { threshold: 0.1 }
    )

    if (serviciosRef.current) {
      observer.observe(serviciosRef.current)
    }

    return () => {
      if (serviciosRef.current) {
        observer.unobserve(serviciosRef.current)
      }
    }
  }, [])

  const handleAgendarCita = () => {
    navigate("/contactanos")
  }

  return (
    <div className={styles.parallaxContainer}>
      <div className={styles.fixedBackgroundContainer}>
        <img
          src={backgroundImage || "/placeholder.svg"}
          alt=""
          className={styles.fixedBackground}
        />

        <div className={styles.contentWrapper}>
          {/* Enlace para volver */}
          <Link to="/" className={styles.volverBtn || "volver-btn"}>
            ← Volver
          </Link>
          
          {/* Sección Perfil */}
          <section id="perfil" className={styles.perfilseccion}>
            <div className={styles.perfilcontenido}>
              <div className={styles.perfilimagencontainer}>
                <img
                  src={profileImage || "/placeholder.svg"}
                  alt="Dra. Gladys Eugenia Quintero Capera"
                  className={styles.perfilimagen}
                />
              </div>
              <div className={styles.perfiltextocontainer}>
                <h2 className={styles.perfiltitulo}>Dra. Gladys Eugenia Quintero Capera</h2>
                <h3 className={styles.perfilsubtitulo}>
                  Médica Estética | Especialista en Medicina Regenerativa y Antienvejecimiento
                </h3>
                <p className={styles.perfilparrafo}>
                  La Dra. Gladys Eugenia Quintero Capera es una médica estética con experiencia en el cuidado de la piel,
                  la armonización facial, corporal y los tratamientos antienvejecimiento...
                </p>
                <p className={styles.perfilparrafo}>
                  Su compromiso es ofrecer tratamientos personalizados con productos de la más alta calidad...
                </p>
              </div>
            </div>
          </section>

          {/* Formación */}
          <section id="formacion" className={styles.perfilseccion}>
            <h2 className={styles.perfiltitulo}>Formación Académica</h2>
            <ul className={styles.perfillista}>
              <li className={styles.perfilitem}>
                <h3 className={styles.perfilsubtitulo}>Médica - Universidad de Manizales, 2009</h3>
                <p className={styles.perfilparrafo}>
                  Formación como médica general con enfoque en atención integral al paciente.
                </p>
              </li>
              <li className={styles.perfilitem}>
                <h3 className={styles.perfilsubtitulo}>
                  Especialista en Medicina Estética, Terapias Anti-Envejecimiento y Alternativas - Universidad del Quindío
                </h3>
                <p className={styles.perfilparrafo}>
                  Especialización enfocada en técnicas avanzadas de medicina estética...
                </p>
              </li>
              <li className={styles.perfilitem}>
                <h3 className={styles.perfilsubtitulo}>Formación Continua - Congresos Nacionales</h3>
                <p className={styles.perfilparrafo}>
                  Participación activa en congresos y capacitaciones sobre las últimas tendencias...
                </p>
              </li>
            </ul>
          </section>

          {/* Experiencia */}
          <section id="experiencia" className={styles.perfilseccion}>
            <h2 className={styles.perfiltitulo}>Experiencia Profesional</h2>
            <ul className={styles.perfillista}>
              <li className={styles.perfilitem}>
                <h3 className={styles.perfilsubtitulo}>Médica Estética Especializada</h3>
                <p className={styles.perfilparrafo}>
                  Tratamientos minimamente invasivos con resultados naturales y personalizados.
                </p>
              </li>
              <li className={styles.perfilitem}>
                <h3 className={styles.perfilsubtitulo}>Especialista en Medicina Regenerativa</h3>
                <p className={styles.perfilparrafo}>
                  Suero terapia, terapia neural, armonización facial y rejuvenecimiento.
                </p>
              </li>
              <li className={styles.perfilitem}>
                <h3 className={styles.perfilsubtitulo}>Compromiso con la Excelencia</h3>
                <p className={styles.perfilparrafo}>
                  Capacitación constante para ofrecer tratamientos actualizados y seguros.
                </p>
              </li>
            </ul>
          </section>

          {/* Servicios */}
          <section id="servicios" className={styles.perfilseccion} ref={serviciosRef}>
            <h2 className={styles.perfiltitulo}>Servicios</h2>
            <div className={styles.perfilservicios}>
              <div className={styles.servicioitem}>
                <h3 className={styles.perfilsubtitulo}>Medicina Estética</h3>
                <p className={styles.perfilparrafo}>
                  Armonización facial con productos de calidad.
                </p>
              </div>
              <div className={styles.servicioitem}>
                <h3 className={styles.perfilsubtitulo}>Medicina Regenerativa</h3>
                <p className={styles.perfilparrafo}>
                  Terapias avanzadas para regeneración celular.
                </p>
              </div>
              <div className={styles.servicioitem}>
                <h3 className={styles.perfilsubtitulo}>Tratamientos Antienvejecimiento</h3>
                <p className={styles.perfilparrafo}>
                  Procedimientos seguros para rejuvenecer tu imagen.
                </p>
              </div>
            </div>
          </section>

          {/* Llamado a la acción */}
          <section id="cta" className={`${styles.perfilseccion} ${styles.ctaSection}`}>
            <h2 className={styles.perfiltitulo}>¡Potencia tu mejor versión!</h2>
            <p className={styles.perfilparrafo}>
              Descubre cómo resaltar tu belleza con tratamientos seguros y de última tecnología.
            </p>
            <p className={styles.perfilparrafo}>¡Agenda tu cita y comienza tu transformación hoy mismo!</p>
            <button onClick={handleAgendarCita} className={styles.ctaButton}>
              Agendar Cita
            </button>
          </section>
        </div>
      </div>
    </div>
  )
}

export default NosotrosParallax